/* eslint-disable camelcase */
/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CModalTitle,
  CCardFooter,
  CCardHeader,
  CCardTitle,
  CListGroup,
  CListGroupItem,
  CModalHeader,
  Alert,
  CCardSubtitle,
  CCol,
  CRow
} from "@coreui/react";
import { IoClose } from "react-icons/io5";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setEvaluation } from "../../actions/evaluationActions";
import calendar from "../../assets/imgs/calendarSimple.png";
import checklist from "../../assets/imgs/checklist-checked-box.png";
import clock from "../../assets/imgs/clock-circular-outline.png";
import URL from "../../config/api";
import axios from "../../config/axios";
import { log } from "../../utils/log";
import ApplicatedQuestion from "../ApplicatedQuestion/ApplicatedQuestion";
import Countdown from "../Countdown";
import "./styles.css";
import Loading from "../Loading";

class ApplicatedQuestionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allocation_id: this.props.allocation_id,
      listId: this.props.id,
      loading: true,
      prototype: this.props.prototype,
      finished: false,
      currentTime: null,
      name: undefined,
      questions: [],
      simulated: false,
      random: false,
      time: this.props.time,
      time_spent: 0,
      fullTime: 0,
      start: { fullDate: undefined, timeStamp: undefined },
      end: undefined,
      value: null,
      executions: 0,
      randomizer: [],
      applications: [],
      applicationId: null,
      hasOpenQuestions: false,
      user_id: null,
      types: [],
      items: [],
      options: [],
      disabledStart: false,
      questionList: null,
      showConfirmStart: false,
      confirmFinish: false,
      answers: {
        score: 0,
        scoreValue: 0,
        answers: []
      },
      final_grade: 0,
      try: null,
      tempoRestante: 3000
    };

    this.updateTimeout = null;

    this.listAnswerChanger = this.changeListAnswers.bind(this);
    this.handleFinishListApplication = this.finishListApplication.bind(this);
    this.showAnswers = this.showAnswers.bind(this);
    this.handleCurrentTime = this.handleCurrentTime.bind(this);
    this.showConfirmStartEvaluation =
      this.showConfirmStartEvaluation.bind(this);
    this.splitDateHour = this.splitDateHour.bind(this);
  }

  componentDidMount() {
    const startMark = this.getCurrentDate();
    this.setState({
      start: { fullDate: startMark.currentTime, timeStamp: startMark.timeStamp }
    });
    this.pullApplications();

    if (
      this.props.general.active_roles.role_id !== 7 &&
      this.props.general.active_roles.role_id !== 9
    ) {
      this.pullListTeachers();
    }
  }

  updateTimeSpentEachFiveMinutes() {
    const fullWait = 360000 + Math.floor(Math.random() * (20000 - 1000) + 1000);

    this.interval = setInterval(() => {
      this.updatedListApplication();
    }, fullWait);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  pullApplications() {
    const filter = {
      user_id: this.props.user.user.id,
      allocation_id: this.state.allocation_id,
      list_id: this.state.listId
    };

    axios
      .post(`${URL.api}evaluation/application/getTryInfo`, filter, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let applicationsLength = resp.data?.data.length;
        let hasOpenEvaluation =
          resp.data.data[applicationsLength - 1]?.end === null;
        let spent = resp.data.data[applicationsLength - 1]?.time_spent;

        this.setState({
          time_spent: spent,
          applications: resp.data.data,
          hasOpenEvaluation,
          loading: false
        });
      });
  }

  createLog() {
    if (!this.props.prototype) {
      log(
        "access",
        this.props.currentRoute,
        `Acessou a lista ${this.state.name}${
          this.props.activityId
            ? ` dentro da atividade com id ${this.props.activityId}`
            : ""
        }`,
        this.state.listId,
        this.props.user.token,
        this.props.activityId || null,
        this.props.general.active_roles.school_id || null
      );
    }
  }

  pullList(id) {
    axios
      .get(`${URL.api}evaluation/type_question/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ types: resp.data.data });
      });

    axios
      .get(`${URL.api}evaluation/application/newSingleView/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(response => {
        const answersArray = response.data.data.questions.map(answer => ({
          questionId: answer.questions[0].id,
          correction: false,
          answer: JSON.parse("{}"),
          value: answer.questions[0].value
        }));
        let answers = response.data.data.answers;
        let questions = response.data.data.questions.map(question => {
          let questionAnswer = answers.find(
            answer => answer.question_id === question.question_id
          );
          let obj = {
            answer_id: questionAnswer?.answer_id || null,
            question_id: question.question_id,
            start: this.getCurrentDate().currentTime,
            end: this.getCurrentDate().currentTime,
            correction: false,
            answer: null,
            correct: false,
            time_spent: null,
            value: question.value,
            answer_given: question.answer_given,
            options: question.questions[0].options.map(option => {
              let optionAnswer = answers.find(
                answer => answer.option_id === option.id
              );
              return {
                answer_option_id: optionAnswer?.answer_option_id || null,
                option_id: option.id,
                order: option.order,
                check_value: optionAnswer?.check_value || null,
                correct_value: option.check_value
              };
            }),
            type_question_id: question.questions[0]?.type_question_id
          };
          return obj;
        });
        let updatedQuestions = response.data.data.questions.map(question => {
          let questionAnswer = answers.find(
            answer => answer.question_id === question.question_id
          );
          question.answer = {
            textAnswer: questionAnswer?.answer
              ? JSON.parse(questionAnswer?.answer).valor
              : null,
            answer: questionAnswer?.answer
              ? JSON.parse(questionAnswer?.answer)
              : null
          };
          question.questions[0].options = question.questions[0]?.options.map(
            option => {
              let optionAnswer = answers.find(
                answer => answer.option_id === option.id
              );
              return {
                ...option,
                checked_value:
                  optionAnswer?.check_value === false ||
                  optionAnswer?.check_value === true
                    ? optionAnswer?.check_value
                    : null
              };
            }
          );
          return question;
        });
        this.setState({
          answers: {
            score: 0,
            scoreValue: 0,
            answers: answersArray
          },
          listId: response.data.data.list_id,
          applicationId: response.data.data.id,
          user_id: response.data.data.user_id,
          matrix_id: response.data.data.matrix_id,
          time_spent: response.data.data.time_spent,
          correct_answers: response.data.data.correct_answers,
          final_grade: response.data.data.final_grade,
          average_question_time: response.data.data.average_question_time,
          edited: response.data.data.edited,
          photo: response.data.data.photo,
          evaluation_lists_jsons_id:
            response.data.data.evaluation_lists_jsons_id,
          name: response.data.data.name,
          time: response.data.data.time * 60,
          value: response.data.data.value,
          fullTime: response.data.data.time,
          executions: response.data.data.execution_quantity,
          loading: false,
          questions,
          questionList: updatedQuestions
        });
        this.setState(state => ({
          try: state.applications.length + 1
        }));
      });
  }

  pullListTeachers() {
    this.setState({ loading: true });
    axios
      .get(`${URL.api}evaluation/type_question/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ types: resp.data.data });
      });

    axios
      .get(
        `${URL.api}evaluation/question/lists/singleViewWithOptions/${this.state.listId}`,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(listResponse => {
        this.setState({
          name: listResponse.data.data.name,
          value: listResponse.data.data.value,
          questionList: listResponse.data.data.questions,
          time: listResponse.data.data.time
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  getformatedDate(date) {
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth() + 1;
    const currentDay = date.getDate();
    const currentHour = date.getHours();
    const currentMinute = date.getMinutes();
    const currentSecond = date.getSeconds();

    const fullDate = `${currentYear}-${currentMonth}-${currentDay} ${currentHour}:${currentMinute}:${currentSecond}`;

    return fullDate;
  }

  getCurrentDate() {
    const timeStamp = new Date().getTime();

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = new Date().getDate();
    const currentHour = new Date().getHours();
    const currentMinute = new Date().getMinutes();
    const currentSecond = new Date().getSeconds();

    const fullDate = `${currentYear}-${currentMonth}-${currentDay} ${currentHour}:${currentMinute}:${currentSecond}`;

    const timeSpent = Math.floor(
      (timeStamp - this.state.start.timeStamp) / 60000
    );

    return { currentTime: fullDate, timeStamp, timeSpent };
  }

  changeListAnswers(optionID, questionID, insertValue) {
    let questionChanged;
    let questions = this.state.questions.map(question => {
      let obj = question;
      if (questionID === question.question_id) {
        let answerGiven = 0;
        // Percorrendo opções
        let optionsChanged = [];
        let options = question.options.map(option => {
          if (option.option_id === optionID) {
            obj = {
              ...option,
              check_value: insertValue,
              interacted: true
            };

            answerGiven = option?.order || 0;

            return obj;
          }
          if (question.type_question_id === 2 && option.check_value === true) {
            optionsChanged.push({
              ...option,
              check_value: false,
              interacted: true
            });
          }
          if (question.type_question_id === 2) {
            return { ...option, check_value: false };
          }
          if (
            question.type_question_id === 3 ||
            (question.type_question_id === 4 && option.option_id !== optionID)
          ) {
            optionsChanged.push({ ...option, interacted: false });
          }

          return option;
        });

        obj = {
          ...question,
          options,
          answer_given: answerGiven
        };

        // Verificando resposta
        if (insertValue === true) {
          let answer = {
            valor: question.value
          };
          let correct = true;
          obj = { ...obj, answer, correct };
        } else {
          let correct = false;
          // Em caso de questões discursivas, aqui é onde coloca o valor
          let answer = {
            valor: insertValue?.textAnswer
          };
          obj = { ...obj, answer, correct };
        }

        // Montando objeto para resposta
        questionChanged = [
          {
            answer_id: obj.answer_id,
            question_id: obj.question_id,
            type_question_id: obj.type_question_id,
            question_value: obj.value,
            start: this.getCurrentDate().currentTime,
            end: this.getCurrentDate().currentTime,
            answer: obj.answer,
            time_spent: 0,
            correct: obj.correct,
            answer_given: obj.answer_given,
            options: obj.options
          }
        ];
      }
      return obj;
    });
    // Se for questão discursiva
    if (!(typeof insertValue === "boolean")) {
      this.setState({ questions });
      if (this.updateTimeout) clearTimeout(this.updateTimeout);

      this.updateTimeout = setTimeout(
        () =>
          this.updatedListApplication(
            questionChanged,
            questions,
            questionID,
            optionID
          ),
        500
      );
    } else {
      this.updatedListApplication(
        questionChanged,
        questions,
        questionID,
        optionID
      );
      this.setState({ questions });
    }
  }

  finishListApplication() {
    this.setState(
      { finished: true, confirmFinish: false, disabledStart: false },
      () => {
        if (this.props.currentItem) {
          this.props.updateCompletionItem(this.props.currentItem);
        }
        this.props.setEvaluation({ time: null });
      }
    );

    let answers = this.state.questions.map(question => {
      let options = question.options.map(option => {
        let obj = {
          answer_option_id: option.answer_option_id,
          option_id: option.option_id,
          order: option.order,
          check_value: option.check_value,
          correct_value: option.correct_value,
          interacted: !option.answer_option_id
        };
        return obj;
      });
      let answer = {
        answer_id: question.answer_id,
        question_id: question.question_id,
        type_question_id: question.type_question_id,
        question_value: question.value,
        start: this.getCurrentDate().currentTime,
        end: this.getCurrentDate().currentTime,
        answer: question.answer,
        time_spent: 0,
        correct: question.correct,
        answer_given: question.answer_given,
        options
      };
      return answer;
    });

    const obj = {
      application_id: this.state.applicationId,
      answers
    };

    if (!this.props.prototype) {
      axios
        .post(`${URL.api}evaluation/application/newFinish`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          const obj = {
            execution_id: this.props.execution_id,
            item_id: this.props.item_id,
            completion_percentage: 100,
            final_grade: resp.data.data.final_grade,
            start: this.getCurrentDate().currentTime,
            end: new Date(
              Date.now() - new Date().getTimezoneOffset() * 60 * 1000
            ).toISOString()
          };
          axios
            .post(`${URL.api}activity/execution/item/insert`, obj, {
              headers: {
                authorization: `Bearer ${this.props.user.token}`,
                "Access-Control-Allow-Origin": "*"
              }
            })
            .then(res => {
              toastr.success("Finalizado", "Prova enviada com sucesso!", {
                timeOut: 10000
              });
              if (this.props.isTrailActivity) {
                const obj = {
                  activityId: this.props.activityId,
                  executionId: this.props.execution_id
                };
                localStorage.setItem(
                  `${this.props.activityId}`,
                  JSON.stringify(obj)
                );
              }
            });
        });
      // TODO GET MORE APPICATIONS
    }
  }

  updatedListApplication(questionChanged, questions, questionID, optionID) {
    if (!this.props.prototype) {
      const obj = {
        id: this.state.applicationId, // receber
        time_spent: this.state.time - this.state.currentTime, // receber
        answers: questionChanged
      };

      axios
        .post(`${URL.api}evaluation/application/newUpdate`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(response => {
          let answer_id = response.data.data[0].id;
          let answer_option_id = response.data.data[0].options.find(
            option => option.option_id === optionID
          )?.id;
          let questionsUpdated = questions.map(question => {
            if (questionID === question.question_id) {
              question.answer_id = answer_id;
              question.options.map(option => {
                if (option.option_id === optionID) {
                  option.answer_option_id = answer_option_id;
                }
                return option;
              });
            }
            return question;
          });
          this.setState({ questions: questionsUpdated });
        });
    }
  }

  showConfirmStartEvaluation() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ showConfirmStart: !this.state.showConfirmStart });
  }

  newTry(isOldTry = false) {
    localStorage.setItem(`${this.props.activityId}`, "");
    this.setState({ disabledStart: true });
    this.updateTimeSpentEachFiveMinutes();
    if (isOldTry) {
      let lengthActivities = this.state.applications?.length;
      this.pullList(this.state.applications[lengthActivities - 1].id);
    } else {
      const obj = {
        allocation_id: this.state.allocation_id,
        list_id: this.state.listId,
        user_id: this.props.user.user.id,
        start: this.getCurrentDate().currentTime,
        try: this.state.applications.length + 1,
        edited: false
      };

      axios
        .post(`${URL.api}evaluation/application/newInsert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(response => {
          const answersArray = response.data.data.lists_questions.map(
            answer => ({
              questionId: answer.questions[0].id,
              correction: false,
              answer: JSON.parse("{}"),
              value: answer.questions[0].value
            })
          );
          let questions = response.data.data.lists_questions.map(question => {
            let obj = {
              answer_id: null,
              question_id: question.question_id,
              start: this.getCurrentDate().currentTime,
              end: this.getCurrentDate().currentTime,
              correction: false,
              answer: null,
              correct: false,
              time_spent: null,
              value: question.value,
              answer_given: question.answer_given,
              options: question.questions[0].options.map((option, index) => ({
                answer_option_id: null,
                option_id: option.id,
                order: option.order,
                check_value: null,
                correct_value: option.check_value
              })),
              type_question_id: question.questions[0]?.type_question_id
            };
            return obj;
          });
          let lists_questions = response.data.data.lists_questions.map(
            question => {
              let options = question.questions[0].options.map(option => ({
                ...option,
                checked_value: null
              }));
              question.questions[0].options = options;
              return question;
            }
          );
          this.setState({
            answers: {
              score: 0,
              scoreValue: 0,
              answers: answersArray
            },
            listId: response.data.data.list_id,
            applicationId: response.data.data.id,
            user_id: response.data.data.user_id,
            matrix_id: response.data.data.matrix_id,
            time_spent: response.data.data.time_spent,
            correct_answers: response.data.data.correct_answers,
            final_grade: response.data.data.final_grade,
            average_question_time: response.data.data.average_question_time,
            edited: response.data.data.edited,
            photo: response.data.data.photo,
            evaluation_lists_jsons_id:
              response.data.data.evaluation_lists_jsons_id,
            name: response.data.data.name,
            time: response.data.data.time * 60,
            value: response.data.data.value,
            fullTime: response.data.data.time,
            executions: response.data.data.execution_quantity,
            loading: false,
            questions,
            questionList: lists_questions
          });
          this.setState(state => ({
            try: state.applications.length + 1,
            showConfirmStart: false,
            disabledStart: false
          }));
        });

      this.createLog(); // tirar daqui. Colocar em um lugar que chama só uma vez quando inicia a avaliação
    }
  }

  showGrade() {
    if (["SEMPRE", "NOTA"].includes(this.props.result_type)) {
      return true;
    }

    if (this.props.result_type === "TERMINO" && this.props.ended) {
      return true;
    }

    return false;
  }

  showAnswers() {
    if (this.props.result_type === "SEMPRE") {
      return true;
    }

    if (
      ["TERMINO", "NOTA"].includes(this.props.result_type) &&
      this.props.ended
    ) {
      return true;
    }

    return false;
  }

  splitDateHour(dataString) {
    if (!dataString) return { date: "", hours: "" };

    const [data, hora] = dataString.split(" ");

    const [ano, mes, dia] = data.split("-");
    const [horas, minutos, segundos] = hora.split(":");

    const dataFormatada = `${dia}/${mes}/${ano}`;
    const horaFormatada = `${horas}:${minutos}:${segundos}`;

    return {
      date: dataFormatada,
      hours: horaFormatada
    };
  }

  handleCurrentTime(value) {
    this.setState(prevState => ({
      currentTime: value,
      time_spent: prevState.time - value
    }));
  }

  render() {
    const numberOfExecutions = this.state.applications.length;

    // Tela inicial do Componente que mostra a criação de Tentativa e relacionados. A prova em si é renderizada nos returns que vêm após aqui.
    if (
      this.state.try === null &&
      (this.props.general.active_roles.role_id === 7 ||
        this.props.general.active_roles.role_id === 9)
    ) {
      return (
        <React.Fragment>
          {!this.state.loading ? (
            <div style={{ backgroundColor: "#F8F8FA" }}>
              <CCol className="container-display-question m-0 p-0 pl-3 pr-3">
                <h1 className="mt-5">Avaliação Online</h1>
                <div>
                  {this.state.hasOpenEvaluation ? (
                    <div
                      style={{
                        marginTop: "40px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                      }}
                    >
                      <div style={{ display: "flex", gap: "60px" }}>
                        <div
                          className="block-information-question"
                          style={{ marginBottom: "20px" }}
                        >
                          <h5>Tempo Restante:</h5>
                          <div className="information-question">
                            <img
                              src={clock}
                              alt="calendar"
                              className="img-information-question"
                            />
                            <span className="title-information-question">
                              {this.state.time === 0
                                ? "Ilimitado"
                                : `${Math.floor(
                                    (this.props.evaluation?.time
                                      ? this.props.evaluation.time
                                      : this.state.time * 60 -
                                        this.state.time_spent) / 60
                                  )} min`}
                            </span>
                          </div>
                        </div>
                      </div>
                      <CButton
                        color="primary"
                        style={{ fontSize: "19px", padding: "8px 24px" }}
                        onClick={() => this.newTry(true)}
                      >
                        Continuar
                      </CButton>
                    </div>
                  ) : (
                    <>
                      <CRow className="container-information-question">
                        <CCol md="3" className="block-information-question m-0">
                          <h5>Tentativas disponíveis:</h5>
                          <div className="information-question">
                            <img
                              src={checklist}
                              alt="calendar"
                              style={{ height: "auto", width: "39px" }}
                            />
                            <span className="title-information-question">
                              {/* sem limite de tentativas */}
                              {(this.props.executionQuantity === 0 ||
                                !this.props.executionQuantity) && (
                                <span>Ilimitadas</span>
                              )}

                              {/* tentativas esgotadas */}
                              {this.props.executionQuantity -
                                numberOfExecutions <=
                                0 &&
                                this.props.executionQuantity !== 0 && (
                                  <span>0</span>
                                )}

                              {/* Tentativas totais restantes */}
                              {this.props.executionQuantity -
                                numberOfExecutions >
                                0 && (
                                <span>
                                  {this.props.executionQuantity -
                                    numberOfExecutions}
                                </span>
                              )}
                            </span>
                          </div>
                        </CCol>
                        <CCol md="3" className="block-information-question m-0">
                          <h5>Data limite para realização:</h5>
                          <div className="information-question">
                            <img
                              src={calendar}
                              alt="calendar"
                              className="img-information-question"
                            />
                            <span className="title-information-question">
                              {this.props.end_date
                                ? this.splitDateHour(this.props.end_date).date
                                : "Sem data limite"}
                            </span>
                          </div>
                        </CCol>
                        <CCol md="3" className="block-information-question m-0">
                          <h5>Hora limite para realização:</h5>
                          <div className="information-question">
                            <img
                              src={calendar}
                              alt="calendar"
                              className="img-information-question"
                            />
                            <span className="title-information-question">
                              {this.props.end_date
                                ? this.splitDateHour(this.props.end_date).hours
                                : "Sem hora limite"}
                            </span>
                          </div>
                        </CCol>
                        <CCol md="3" className="block-information-question m-0">
                          <h5>Tempo limite para realização:</h5>
                          <div className="information-question">
                            <img
                              src={clock}
                              alt="calendar"
                              className="img-information-question"
                            />

                            <span className="title-information-question">
                              {Number(this.state.time) === 0 || !this.state.time
                                ? "Ilimitado"
                                : `${this.state.time} min`}
                            </span>
                          </div>
                        </CCol>
                      </CRow>
                      <div className="container-button-question">
                        {this.state.showConfirmStart && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center"
                            }}
                          >
                            <h4>
                              Você tem certeza que deseja iniciar a Avaliação?
                            </h4>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                marginTop: "10px"
                              }}
                            >
                              <CButton
                                onClick={() => this.newTry()}
                                color="primary"
                                disabled={this.state.disabledStart}
                                style={{
                                  fontSize: "12px",
                                  padding: "8px 18px"
                                }}
                              >
                                Sim
                              </CButton>
                              <CButton
                                onClick={() =>
                                  this.showConfirmStartEvaluation()
                                }
                                color="danger"
                                style={{
                                  fontSize: "12px",
                                  padding: "8px 18px"
                                }}
                              >
                                Não
                              </CButton>
                            </div>
                          </div>
                        )}
                        {((!this.state.showConfirmStart &&
                          this.props.executionQuantity - numberOfExecutions >
                            0 &&
                          this.props.executionQuantity !== 0) ||
                          (this.props.executionQuantity === 0 &&
                            !this.state.showConfirmStart)) && (
                          <>
                            {new Date(this.props.end_date) <= new Date() ? (
                              <h5 className="display-4">Avaliação Expirada</h5>
                            ) : (
                              <CButton
                                onClick={() =>
                                  this.showConfirmStartEvaluation()
                                }
                                color="primary"
                                disabled={
                                  new Date(this.props.end_date) <= new Date()
                                }
                                style={{
                                  fontSize: "19px",
                                  padding: "8px 24px",
                                  width: "260px"
                                }}
                              >
                                Iniciar Avaliação
                              </CButton>
                            )}
                          </>
                        )}
                        {this.props.executionQuantity - numberOfExecutions <=
                          0 &&
                          this.props.executionQuantity !== 0 && (
                            <h4>Número de tentativas excedido</h4>
                          )}
                      </div>
                    </>
                  )}
                </div>
                <div
                  style={{
                    width: "70%",
                    display: "grid",
                    grid: "row",
                    gridGap: "5px",
                    marginTop: "60px",
                    marginBottom: "20px",
                    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))" // Define o grid com até 4 colunas
                  }}
                >
                  {" "}
                  {this.state.applications &&
                  this.state.applications.length > 0 ? (
                    this.state.applications.map(item => {
                      if (item.end !== null) {
                        return (
                          <>
                            <div
                              style={{
                                borderColor: "#e9e9e9",
                                borderStyle: "solid",
                                borderWidth: "1px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "8px"
                              }}
                            >
                              <i className="fa fa-check-square text-primary mr-2"></i>
                              <div className="flex-1 text-muted">
                                Tentativa {item.try}{" "}
                                {this.showGrade()
                                  ? ` (${
                                      item.final_grade && item.end !== null
                                        ? `Nota: ${item.final_grade}`
                                        : "Aguardando correção"
                                    })`
                                  : ""}
                              </div>
                            </div>
                          </>
                        );
                      }
                      return (
                        <>
                          <div
                            style={{
                              borderColor: "#e9e9e9",
                              borderStyle: "solid",
                              borderWidth: "1px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "8px"
                            }}
                          >
                            <i className="fa fa-check-square text-primary mr-2"></i>
                            <div className="flex-1 text-muted">
                              Tentativa {item.try} (Em execução)
                            </div>
                          </div>
                        </>
                      );
                    })
                  ) : (
                    <CListGroupItem className="d-flex align-items-center mb-5">
                      <div className="flex-1 text-muted">
                        Nenhuma tentativa realizada
                      </div>
                    </CListGroupItem>
                  )}
                </div>
              </CCol>
            </div>
          ) : (
            <div className="applicated-question-list-container d-flex flex-column align-items-center justify-content-center">
              <Loading />
            </div>
          )}
        </React.Fragment>
      );
    }

    // Tela de renderização da prova

    // Esse if checa se é aluno ou visitante, pois a tela é diferente para os outros.
    if (
      this.props.general.active_roles.role_id === 7 ||
      this.props.general.active_roles.role_id === 9
    ) {
      return (
        <React.Fragment>
          <>
            <div>
              <CRow className="header-execution-list d-flex flex-1 justify-content-between align-items-center pb-3 pl-5 pr-5">
                <CCol sm="12" md="4" className="mt-3">
                  {this.state.name}
                  <div className="d-flex">
                    <section className="d-flex">
                      <h6>Valor da avaliação:&nbsp;</h6>
                      <h6 style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                        {this.state.value}
                      </h6>
                    </section>
                  </div>
                </CCol>
                <CCol className="d-flex justify-content-center align-items-center mt-3">
                  {this.state.time > 0 && (
                    <Countdown
                      time={
                        this.state.time_spent !== 0
                          ? this.state.time - this.state.time_spent
                          : this.state.time
                      }
                      setTime={time => this.setState({ time })}
                      handleFinishTime={() =>
                        this.handleFinishListApplication()
                      }
                      disable={this.state.finished}
                      handleCurrentTime={this.handleCurrentTime}
                    />
                  )}
                </CCol>
                <CCol className="applicated-question-list-navigation-menu mt-3">
                  {!this.state.finished ? (
                    <>
                      {!this.state.confirmFinish ? (
                        <button
                          className="applicated-question-list-submit-button p-2"
                          onClick={() => this.setState({ confirmFinish: true })}
                        >
                          Finalizar avaliação
                        </button>
                      ) : (
                        <>
                          <button
                            className="applicated-question-list-submit-button p-2 text-white"
                            onClick={() => this.finishListApplication()}
                          >
                            Confirmar
                          </button>
                          <button
                            className="applicated-question-list-submit-button p-2 bg-danger"
                            onClick={() =>
                              this.setState({ confirmFinish: false })
                            }
                          >
                            <IoClose color="#FFFFFF" size={20} />
                          </button>
                        </>
                      )}
                    </>
                  ) : (
                    <React.Fragment>
                      {this.state.prototype ? (
                        <React.Fragment>
                          <button
                            className="applicated-question-list-back-button"
                            onClick={() => this.setState({ finished: false })}
                          >
                            Tentar Novamente
                          </button>
                        </React.Fragment>
                      ) : (
                        <button
                          className="applicated-question-list-submit-button"
                          onClick={async () => {
                            this.props.close();
                            await this.pullApplications();
                            // Se for uma nova tentativa volta para a tela inicial e reseta o tempo
                            this.setState({
                              try: null,
                              finished: false,
                              time: this.props.time
                            });
                          }}
                        >
                          Voltar
                        </button>
                      )}
                    </React.Fragment>
                  )}
                  {!this.state.finished && !this.props?.noClose && (
                    <button
                      className="applicated-question-list-submit-button p-2 bg-dark"
                      onClick={() => {
                        this.props.close();
                      }}
                    >
                      Fechar
                    </button>
                  )}
                </CCol>
              </CRow>
            </div>
            {!this.state.loading ? (
              <div className="applicated-question-list-container applicated-question-list-container-background">
                <section className="applicated-question-list-question-section">
                  <ul>
                    {this.state.questionList?.map((question, index) => {
                      let options = question.questions[0].options;
                      return (
                        <li key={question.id}>
                          <ApplicatedQuestion
                            questionOrder={index + 1}
                            id={question?.questions[0].id}
                            typeId={question?.questions[0].type_question_id}
                            questionDescription={
                              question?.questions[0].description
                            }
                            grade={question?.questions[0].grade}
                            author={question?.questions[0].author}
                            year={question?.questions[0].year}
                            difficultyLevel={
                              question?.questions[0].difficulty_level_id
                            }
                            options={options}
                            questionFeedback={question?.questions[0].feedback}
                            // feedback={}
                            questionId={question?.questions[0].id}
                            listId={this.state.listId}
                            prototype={false}
                            listApplication
                            finished={this.state.finished}
                            history={this.props.history}
                            listAnswerChanger={this.listAnswerChanger} // comment: essa é a função que chama a cada digitação
                            types={this.state.types}
                            userAnswer={question?.answer}
                            showAnswers={this.showAnswers}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </section>
              </div>
            ) : (
              <div className="applicated-question-list-container">
                <Loading />
              </div>
            )}
          </>
        </React.Fragment>
      );
    }
    // Tela para professores e adms
    return (
      <React.Fragment>
        <>
          <CModalHeader>
            <CModalTitle className="d-flex flex-1 justify-content-between align-items-center pt-1 pb-1 pl-3 pr-3">
              <div>
                {this.state.name}
                <section className="d-flex">
                  <h6>Duração da avaliação:&nbsp;</h6>
                  {this.state.fullTime === 0 ? (
                    <h6>Sem Limite.</h6>
                  ) : (
                    <React.Fragment>
                      <h6
                        style={{
                          color: "rgba(0, 0, 0, 0.4)",
                          paddingLeft: "4px",
                          paddingRight: "2px"
                        }}
                      >
                        {" "}
                        {this.state.fullTime} minutos
                      </h6>
                    </React.Fragment>
                  )}
                </section>
                <section className="d-flex">
                  <h6>Valor da avaliação:&nbsp;</h6>
                  <h6 style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                    {this.state.value}
                  </h6>
                </section>
              </div>
              {this.state.time > 0 && (
                <Countdown
                  time={
                    this.state.time_spent !== 0
                      ? this.state.time - this.state.time_spent
                      : this.state.time
                  }
                  setTime={time => this.setState({ time })}
                  handleFinishTime={() => this.handleFinishListApplication()}
                  disable={this.state.finished}
                  handleCurrentTime={this.handleCurrentTime}
                />
              )}

              {/* {!this.props.viewModal && (
                <section className="applicated-question-list-navigation-menu">
                  {!this.state.finished ? (
                    <>
                      {!this.state.confirmFinish ? (
                        <button
                          className="applicated-question-list-submit-button p-2"
                          onClick={() => this.setState({ confirmFinish: true })}
                        >
                          Finalizar avaliação
                        </button>
                      ) : (
                        <>
                          <button
                            className="applicated-question-list-submit-button p-2 text-white"
                            onClick={() => this.finishListApplication()}
                          >
                            Confirmar
                          </button>
                          <button
                            className="applicated-question-list-submit-button p-2 bg-danger"
                            onClick={() =>
                              this.setState({ confirmFinish: false })
                            }
                          >
                            Cancelar
                          </button>
                        </>
                      )}
                    </>
                  ) : (
                    <React.Fragment>
                      {this.state.prototype ? (
                        <React.Fragment>
                          <button
                            className="applicated-question-list-back-button"
                            onClick={() => this.setState({ finished: false })}
                          >
                            Tentar Novamente
                          </button>
                        </React.Fragment>
                      ) : (
                        <button
                          className="applicated-question-list-submit-button"
                          onClick={() => this.props.close()}
                        >
                          Voltar
                        </button>
                      )}
                    </React.Fragment>
                  )}
                </section>
              )} */}
            </CModalTitle>
          </CModalHeader>
          {!this.state.loading ? (
            <div className="applicated-question-list-container applicated-question-list-container-background">
              <section className="applicated-question-list-question-section">
                <ul>
                  {this.state.questionList?.map((question, index) => {
                    let options = question.options;
                    return (
                      <li key={question.id}>
                        <ApplicatedQuestion
                          questionOrder={index + 1}
                          id={question?.id}
                          typeId={question?.type_question_id}
                          questionDescription={question?.description}
                          grade={question?.grade}
                          author={question?.author}
                          year={question?.year}
                          difficultyLevel={question?.difficulty_level_id}
                          options={options}
                          questionFeedback={question?.feedback}
                          questionId={question?.id}
                          listId={this.state.listId}
                          prototype={false}
                          listApplication
                          finished={this.state.finished}
                          history={this.props.history}
                          listAnswerChanger={this.listAnswerChanger}
                          types={this.state.types}
                          showAnswers={this.showAnswers}
                        />
                      </li>
                    );
                  })}
                </ul>
              </section>
            </div>
          ) : (
            <div className="applicated-question-list-container">
              <Loading />
            </div>
          )}
        </>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  evaluation: state.evaluation
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setEvaluation
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicatedQuestionList);
